(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-product-sales"] && !Shopify.designMode) return;
  try {
    
function initSalesImages(scope){scope.querySelectorAll('.dc-sales').forEach(root=>{if(root.dataset.salesReady)return;root.dataset.salesReady='true';root.querySelectorAll('[data-sales-image]').forEach(button=>button.addEventListener('click',()=>{const image=root.querySelector('.dc-sales__main-image');image.removeAttribute('srcset');image.src=button.dataset.salesImage;image.alt=button.dataset.salesAlt;}));});}initSalesImages(document);document.addEventListener('shopify:section:load',event=>initSalesImages(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-profitec-go"] && !Shopify.designMode) return;
  try {
    
function initGoImages(scope){scope.querySelectorAll('.dc-go').forEach(root=>{if(root.dataset.goReady)return;root.dataset.goReady='true';root.querySelectorAll('[data-go-image]').forEach(button=>button.addEventListener('click',()=>{const image=root.querySelector('.go-main-image');image.removeAttribute('srcset');image.src=button.dataset.goImage;image.alt=button.dataset.goAlt;}));});}initGoImages(document);document.addEventListener('shopify:section:load',event=>initGoImages(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Read-more für Collection-Texte auf Mobile
  function initCollectionReadMore() {
    if (window.innerWidth >= 750) return;

    const WORD_THRESHOLD = 100;

    // Ziel-Elemente: Collection-Description (rte-formatter) + SEO-Content-Block
    const candidates = [
      ...document.querySelectorAll('rte-formatter'),
      document.querySelector('.diecrema-seo-content__inner'),
    ].filter(Boolean);

    candidates.forEach((el) => {
      const wordCount = (el.textContent || '').trim().split(/\s+/).filter((w) => w.length > 0).length;
      if (wordCount <= WORD_THRESHOLD) return;

      el.classList.add('dc-read-more');

      const btn = document.createElement('button');
      btn.className = 'dc-read-more__btn';
      btn.textContent = 'Zeig mir mehr';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('type', 'button');

      btn.addEventListener('click', () => {
        const expanded = el.classList.toggle('dc-read-more--expanded');
        btn.textContent = expanded ? 'Weniger anzeigen' : 'Zeig mir mehr';
        btn.setAttribute('aria-expanded', String(expanded));
      });

      el.insertAdjacentElement('afterend', btn);
    });
  }

  document.addEventListener('DOMContentLoaded', initCollectionReadMore);

  } catch(e) { console.error(e); }
})();
})();
